import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosPrivate from 'config/axiosPrivate';

function normalizeWebsiteListPayload(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.data)) return data.data;
  if (data && Array.isArray(data.websites)) return data.websites;
  return [];
}

export const fetchAdminClientClientList = createAsyncThunk(
  'adminClientClientList/fetchAdminClientClientList',
  async (arg, thunkAPI) => {
    try {
      const response = await axiosPrivate.get('/project/website/all');
      if (response.status === 200) {
        return normalizeWebsiteListPayload(response.data);
      }
      return thunkAPI.rejectWithValue(response.status);
    } catch (e) {
      return thunkAPI.rejectWithValue(
        e.response?.data ?? e.message ?? 'fetchAdminClientClientList failed'
      );
    }
  },
  {
    condition: (arg, { getState }) => {
      if (arg && typeof arg === 'object' && arg.force === true) return true;
      const { isLoadingClients } = getState().adminClientClientList;
      return !isLoadingClients;
    },
  }
);